// F02 — Følg-med-modus (hjemmebane-integrasjon)
// Leser hjertestatus fra Supabase, og lar appen pushe nåværende
// reisetilstand til public_follow-tabellen så /folg-siden er fersk.

import { getSB, SB_READY } from './cloud.js';
import { DAYS } from './data.js';

const SLUG = 'usa26';
const LS_LAST_HEART = 'follow_last_heart_seen';

let cached = { count: 0, latestMessages: [], fetchedAt: 0 };

export function getHeartState(){
  return {
    count: cached.count,
    latestMessages: cached.latestMessages,
    newSinceSeen: Math.max(0, cached.count - (parseInt(localStorage.getItem(LS_LAST_HEART) || '0', 10) || 0)),
  };
}

export function markHeartsSeen(){
  try { localStorage.setItem(LS_LAST_HEART, String(cached.count)); } catch {}
}

export async function refreshHearts(){
  if (!SB_READY) return cached;
  const sb = getSB();
  if (!sb) return cached;
  // Antall (head) + de siste meldingene (max 5 ikke-tomme)
  const [{ count }, { data: msgs }] = await Promise.all([
    sb.from('hearts').select('*', { count: 'exact', head: true }).eq('trip_slug', SLUG),
    sb.from('hearts').select('message,created_at')
       .eq('trip_slug', SLUG).not('message','is',null)
       .order('created_at', { ascending: false }).limit(5),
  ]);
  cached = {
    count: count || 0,
    latestMessages: (msgs || []).map(m => ({ text: m.message, ts: m.created_at })),
    fetchedAt: Date.now(),
  };
  return cached;
}

// Pusher gjeldende reisetilstand til public_follow så /folg viser fersk info.
// Kalles ved diary-save og ved manuell sync.
export async function syncPublicFollow(opts = {}){
  if (!SB_READY) return false;
  const sb = getSB();
  if (!sb) return false;

  const now = new Date();
  const dep = new Date('2026-07-17T13:50:00+02:00');
  const ret = new Date('2026-08-03T15:25:00+02:00');
  const tripDay = (now < dep || now > ret) ? -1 : Math.floor((now - dep) / 86400000);
  const day = tripDay >= 0 ? DAYS[tripDay] : null;

  const payload = {
    slug: SLUG,
    current_stop: opts.stop || (day ? day.title : 'Før avreise'),
    current_day: tripDay >= 0 ? tripDay + 1 : 0,
    last_diary_excerpt: opts.diary || null,
    last_photo_url: opts.photo || null,
    quote: opts.quote || 'Der himmelen møter havet, og fjellene aldri slutter',
    updated_at: new Date().toISOString(),
  };

  const { error } = await sb.from('public_follow').upsert(payload);
  return !error;
}
